import { type LegendItem, LegendItemIcon } from './types';

interface LegendIconProps {
  item: LegendItem;
  index: number;
}

export const LegendIcon = ({ item, index }: LegendIconProps) => {
  if (item.icon === LegendItemIcon.TEXT_ONLY) {
    return <div className="w-4 h-4 shrink-0" aria-hidden="true" />;
  }

  if (item.icon === LegendItemIcon.DASHED) {
    return (
      <div
        aria-hidden="true"
        data-testid={`legend-color-swatch-${index}`}
        className="w-4 h-4 rounded shrink-0 border border-dashed"
        style={{
          backgroundColor: item.color,
          borderColor: item.borderColor || item.color,
        }}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      data-testid={`legend-color-swatch-${index}`}
      className="w-4 h-4 rounded shrink-0"
      style={{ backgroundColor: item.color }}
    />
  );
};
